import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import {
  vueDeviceDetect
} from 'vue-device-detect'

createApp(App).use(store).use(router).use(Antd).use(vueDeviceDetect).mount('#app')
